<template>
  <div class="app-main-content">
    <div class="tabs-container">
      <el-tabs v-model="activeTabName" type="card" style="width: 100%;">
        <el-tab-pane :label="$t('CargoMsg.Cargo_PurchaseRecord')" name="purchaseRecord">
          <purchase-records />
        </el-tab-pane>
        <el-tab-pane :label="$t('CargoMsg.Cargo_InvoiceRecord')" name="invoiceRecord" :lazy="true">
          <invoice-records />
        </el-tab-pane>
        <el-tab-pane :label="$t('CargoMsg.Cargo_AcquisitionRecord')" name="acquisitionRecord" :lazy="true">
          <recipients-records />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import purchaseRecords from './components/invoiceNo/purchaseRecords'
import invoiceRecords from './components/invoiceNo/invoiceRecords'
import recipientsRecords from './components/invoiceNo/recipientsRecords'

export default {
  name: 'InvoiceNo',
  components: { purchaseRecords, invoiceRecords, recipientsRecords },
  data() {
    return {
      activeTabName: 'purchaseRecord'
    }
  }
}
</script>

<style lang="scss">
</style>
